export const getDomainWithoutSubdomain = (urlString: string) => {
    const urlParts = new URL(urlString).hostname.split(".");

    return urlParts
        .slice(0)
        .slice(-(urlParts.length === 4 ? 3 : 2))
        .join(".");
};
